module.exports = __webpack_public_path__ + "img/icon-yewan.6bec8145.png";